import { ValidatorFn } from '@angular/forms';

export default function usernameAlreadyExistValidator(): ValidatorFn {
  return (): {[key: string]: any} => {
    // Always return true.  This is so if the api tells me a username already exist, I can show this error.
    return null ;
  };
}



// WEBPACK FOOTER //
// ./src/validators/usernameAlreadyExistValidator.ts